// src/data/gyms/CheerSportSharksNE.js
export const CheerSportSharksNE = {
  id: "cheersportsharksne",
  name: "Cheer Sport Sharks",
  color: "#0369A1", // Shark Teal/Blue
  lightColor: "#E0F2FE",
  logo: "🦈",

  teams: [
    { id: "starfish", name: "STARFISH", level: "L1 Tiny - Novice" },
    { id: "tealreef", name: "Teal Reef Sharks", level: "L1 Junior - Flex" },
    { id: "tinytreasures", name: "Tiny Treasures", level: "L1 Tiny" },
    { id: "jaws", name: "JAWS", level: "L3 Junior" },
    { id: "obsession", name: "Obsession", level: "L4.2 Senior" },
    { id: "minimateys", name: "Mini Mateys", level: "L1 Mini" },
    { id: "misssharks", name: "Miss Sharks", level: "L6 U18 NT" },
    { id: "lifeguards", name: "Lifeguards", level: "L2 Youth - Flex - Medium" },
  ],

  schedule: [
    // ================= SATURDAY (Dec 13) =================
    {
      day: "Saturday",
      time: "9:37 AM",
      teamId: "starfish",
      meet: "9:16 AM",
      panel: "Hall A",
    },
    {
      day: "Saturday",
      time: "1:18 PM",
      teamId: "tealreef",
      meet: "12:57 PM",
      panel: "Hall B",
    },
    {
      day: "Saturday",
      time: "2:00 PM",
      teamId: "tinytreasures",
      meet: "1:39 PM",
      panel: "Hall B",
    },
    {
      day: "Saturday",
      time: "2:28 PM",
      teamId: "jaws",
      meet: "2:07 PM",
      panel: "Hall B",
    },
    {
      day: "Saturday",
      time: "4:04 PM",
      teamId: "obsession",
      meet: "3:43 PM",
      panel: "Hall A",
    },
    {
      day: "Saturday",
      time: "4:28 PM",
      teamId: "minimateys",
      meet: "4:07 PM",
      panel: "Hall B",
    },
    {
      day: "Saturday",
      time: "5:43 PM",
      teamId: "misssharks",
      meet: "5:22 PM",
      panel: "Hall A",
    },
    {
      day: "Saturday",
      time: "5:46 PM",
      teamId: "lifeguards",
      meet: "5:25 PM",
      panel: "Hall B",
    },

    // ================= SUNDAY (Dec 14) =================
    // Times extracted from Spirit Sports PDF V2

    // Tiny Treasures (Row 183)
    {
      day: "Sunday",
      time: "11:50 AM",
      teamId: "tinytreasures",
      meet: "11:14 AM",
      panel: "Hall B",
    },

    // Teal Reef Sharks (Row 170)
    {
      day: "Sunday",
      time: "10:41 AM",
      teamId: "tealreef",
      meet: "10:05 AM",
      panel: "Hall B",
    },

    // JAWS (Row 191)
    {
      day: "Sunday",
      time: "12:18 PM",
      teamId: "jaws",
      meet: "11:42 AM",
      panel: "Hall B",
    },

    // Obsession (Row 219)
    {
      day: "Sunday",
      time: "2:52 PM",
      teamId: "obsession",
      meet: "2:16 PM",
      panel: "Hall A",
    },

    // Mini Mateys (Row 224)
    {
      day: "Sunday",
      time: "3:10 PM",
      teamId: "minimateys",
      meet: "2:34 PM",
      panel: "Hall B",
    },

    // Miss Sharks (Row 235)
    {
      day: "Sunday",
      time: "4:12 PM",
      teamId: "misssharks",
      meet: "3:36 PM",
      panel: "Hall A",
    },

    // Lifeguards (Row 236)
    {
      day: "Sunday",
      time: "6:01 PM",
      teamId: "lifeguards",
      meet: "5:25 PM",
      panel: "Hall B",
    },

    // Note: STARFISH (Tiny Novice) often performs only one day or early.
    // They did not appear on the Sunday PDF pages provided.
  ],
};
